export const SET_OPTED_IN = "SET_OPTED_IN";
export const SET_ITEM_COUNT = "SET_ITEM_COUNT";
export const SET_IS_AVAILABLE = "SET_IS_AVAILABLE";
